import cn from 'classnames/bind';
import Link from 'next/link';
import PropTypes from 'prop-types';
import { Card } from 'ui';
import { classNameType, colorType } from 'utils/types';

import s from './AboutUsCard.module.scss';

const cx = cn.bind(s);

const colorClass = {
  'orange': 'text-orange',
  'red': 'text-red',
  'mint': 'text-mint',
};

const AboutUsCard = ({
  size = '', children, title, text, linkText, linkUrl, color, className, ...attrs
}) => (
  <Card hasBorder color={color} className={className}>
    <div className={cx('card', { [size]: !!size })} {...attrs}>
      <div className={cx('title', 'md:tp-header-4', { [size]: !!size, 'tp-mobile-header-4': !!size, 'tp-mobile-header-3': !size })}>{title}</div>
      <div className={cx('text', 'tp-mobile-text md:tp-text-small', { [size]: !!size })}>{text}</div>
      {linkText && linkUrl && <div className={cx("lg:mt-[28px] md:mt-[45px] mt-[28px]")}>
        <Link  href={linkUrl} className={cx(colorClass[color] || '', 'font-semibold text-[16px] pb-1 cursor-pointer hover:border-solid border-b-2')}>
          {linkText}
        </Link>
      </div>}
    </div>
  </Card>
);

AboutUsCard.propTypes = {
  title: PropTypes.string,
  color: colorType,
  className: classNameType,
  size: PropTypes.oneOf(['small', '']),
};

export default AboutUsCard;
